<template>
  <div
    class="quiz-music-toggle"
    @click.stop="toggleQuizMusic()"
    :class="{'is-demo-mode': isPlayDemoMode}"
  >
    <div
      class="quiz-music-toggle __wrapper"
      :class="{'light-text': isTextColourLight}"
      v-tooltip="musicTooltip"
    >
      <font-awesome-icon
        icon="volume-up"
        v-if="presentation.isEnableQuizMusic"
        class="text-xl"
      />
      <font-awesome-icon
        icon="volume-mute"
        v-else
        class="text-xl"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'
import PresentationApi from '@/api/presentation'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      isPlayDemoMode: (state) => state.isPlayDemoMode,
    }),
    ...mapGetters(['isTextColourLight']),
    musicTooltip() {
      return this.presentation.isEnableQuizMusic ? this.$i18nPresenter.t('Turn off music') : this.$i18nPresenter.t('Turn on music')
    },
  },
  methods: {
    toggleQuizMusic() {
      this.presentation.isEnableQuizMusic = !this.presentation.isEnableQuizMusic
      this._updatePresentation({
        isEnableQuizMusic: this.presentation.isEnableQuizMusic,
      })
      EventBus.$emit('play-quiz-music', this.presentation.isEnableQuizMusic)
      if (this.presentation.isEnableQuizMusic) {
        Util.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Settings menu > Quiz settings > Enable Quiz Music',
          'presenting mode',
        )
      } else {
        Util.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Settings menu > Quiz settings > Disable Quiz Music',
          'presenting mode',
        )
      }
    },
    async _updatePresentation(payload) {
      this.$store.dispatch('updatePresentation', payload)
      await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.quiz-music-toggle {
  position: absolute;
  cursor: pointer;
  top: 0.25rem;
  left: 2.25rem;
  font-size: 1.4rem;
  z-index: 126;
  transition: all 0.3s ease;
  opacity: 0;
  &.is-demo-mode {
    left: -2rem;
  }
  &.__wrapper {
    @apply rounded-full flex items-center justify-center w-10 h-10 bg-base-30 hover:bg-base-40;
    backdrop-filter: blur(44px);

    &.light-text {
      background-color: rgba(0, 0, 0, 0.36);
    }
    &:hover.light-text {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
